import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import * as stylex from '@stylexjs/stylex';

const spin = stylex.keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' },
});

export const styles = stylex.create({
  info: {
    display: 'flex',
    marginLeft: '16px',
    padding: '8px 16px',
    alignItems: 'center',
    gap: anatomy['space-8'],
    borderRadius: anatomy.borderRadiusS,
    background: colors.primaryInverseBackground,
  },
  spinner: {
    display: 'flex',
    alignItems: 'center',
    animationName: spin,
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
  },
  status: {
    overflow: 'hidden',
    color: colors.primaryInverseText,
    textOverflow: 'ellipsis',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: '20px',
  },
});
